export default __webpack_public_path__ + "static/media/warning-icon.b5221c95.svg";